// Modal "Añadir producto al pedido" — Sub-fase 7.3 + Sub-fase C.
//
// Dos modos:
//
// 1) Producto existente (toggle OFF — default):
//    Operario sabe el ID del producto en el ERP. Se añade override directo.
//    Devuelve { producto_id, barcode?, descripcion, cantidad }.
//
// 2) Producto nuevo (toggle ON — Sub-fase C):
//    Producto no existe en el ERP. Operario rellena dims+peso. El backend
//    crea ProductoPendiente y un override con placeholder. El admin valida
//    después en /admin?tab=pendientes.
//    Devuelve { producto_id: 0, descripcion, barcode?, cantidad,
//               alto_mm, ancho_mm, fondo_mm, peso_g, fragil, no_rotar }.
//
// Resuelve con `undefined` si cancela.

import { icon } from './icons.js';

let _host = null;
function _close() { if (_host) { _host.remove(); _host = null; } }

export function openAnadirProductoModal() {
  return new Promise((resolve) => {
    _host = document.createElement('div');
    document.body.appendChild(_host);

    let cantidad = 1;
    let isNuevo = false;

    _host.innerHTML = `
      <div class="scrim fade-in"><div class="modal" style="max-height:90dvh;overflow-y:auto;">
        <h2>${icon('package', { size: 22 })} Añadir producto al pedido</h2>
        <p class="hint">Para un producto que el cliente pidió por teléfono o que se incluye en este envío sin estar en el pedido original.</p>

        <label style="display:flex;align-items:center;gap:0.5rem;padding:0.5rem;background:var(--c-surface-2);border-radius:6px;cursor:pointer;">
          <input type="checkbox" id="ap-nuevo"/>
          <span><strong>Producto nuevo</strong> — no existe aún en el ERP</span>
        </label>

        <div class="field">
          <label for="ap-desc">Descripción</label>
          <input id="ap-desc" inputmode="text" autocomplete="off" placeholder="Ej: Salsa rosa 500g" required />
        </div>

        <div class="field">
          <label for="ap-barcode">Código EAN (opcional)</label>
          <input id="ap-barcode" inputmode="numeric" autocomplete="off" placeholder="Ej: 8410076999999" />
        </div>

        <!-- Modo "Producto existente" -->
        <div class="field" id="ap-prodid-wrap">
          <label for="ap-prodid">Id de producto en el sistema</label>
          <input id="ap-prodid" type="number" inputmode="numeric" min="1" placeholder="Ej: 999" />
        </div>

        <!-- Modo "Producto nuevo" — dims+peso -->
        <div id="ap-nuevo-wrap" hidden>
          <p class="hint" style="background:var(--c-partial-bg);border:1px solid var(--c-partial-border);color:var(--c-partial);padding:0.5rem 0.75rem;border-radius:6px;">
            ${icon('alert-triangle', { size: 16 })} Se enviará a validación admin. Hasta que un admin lo valide, el producto aparecerá como "pendiente" en el pedido.
          </p>
          <div class="form-grid" style="grid-template-columns:1fr 1fr;gap:0.5rem;">
            <label>Alto (mm)<input id="ap-alto" type="number" inputmode="numeric" min="1" max="5000"/></label>
            <label>Ancho (mm)<input id="ap-ancho" type="number" inputmode="numeric" min="1" max="5000"/></label>
            <label>Fondo (mm)<input id="ap-fondo" type="number" inputmode="numeric" min="1" max="5000"/></label>
            <label>Peso (g)<input id="ap-peso" type="number" inputmode="numeric" min="1"/></label>
          </div>
          <div style="display:flex;gap:1rem;margin-top:0.5rem;font-size:var(--fs-sm);">
            <label><input type="checkbox" id="ap-fragil"/> Frágil</label>
            <label><input type="checkbox" id="ap-norotar"/> No rotar</label>
          </div>
        </div>

        <div class="field">
          <label for="ap-qty">Cantidad</label>
          <div class="stepper">
            <button data-step="-1" aria-label="Restar">−</button>
            <input id="ap-qty" type="number" inputmode="numeric" min="1" value="${cantidad}">
            <button data-step="+1" aria-label="Sumar">+</button>
          </div>
        </div>

        <div class="actions">
          <button class="btn --ghost" id="ap-cancel">Cancelar</button>
          <button class="btn --primary" id="ap-save">Añadir al pedido</button>
        </div>
      </div></div>`;

    const $ = (id) => _host.querySelector(id);
    const toggleNuevo = $('#ap-nuevo');
    const prodidWrap = $('#ap-prodid-wrap');
    const nuevoWrap = $('#ap-nuevo-wrap');
    const desc = $('#ap-desc');
    const barcode = $('#ap-barcode');
    const prodid = $('#ap-prodid');
    const qty = $('#ap-qty');
    const alto = $('#ap-alto');
    const ancho = $('#ap-ancho');
    const fondo = $('#ap-fondo');
    const peso = $('#ap-peso');
    const fragil = $('#ap-fragil');
    const norotar = $('#ap-norotar');

    setTimeout(() => desc.focus(), 50);

    toggleNuevo.addEventListener('change', () => {
      isNuevo = toggleNuevo.checked;
      prodidWrap.hidden = isNuevo;
      nuevoWrap.hidden = !isNuevo;
    });

    _host.querySelectorAll('button[data-step]').forEach(b => {
      b.addEventListener('click', () => {
        const delta = parseInt(b.dataset.step, 10);
        cantidad = Math.max(1, cantidad + delta);
        qty.value = cantidad;
      });
    });

    $('#ap-cancel').addEventListener('click', () => { _close(); resolve(undefined); });
    $('#ap-save').addEventListener('click', () => {
      const d = desc.value.trim();
      const q = parseFloat(qty.value);
      if (!d) { desc.focus(); return; }
      if (!Number.isFinite(q) || q < 1) { qty.focus(); return; }

      if (isNuevo) {
        const a = parseInt(alto.value, 10);
        const w = parseInt(ancho.value, 10);
        const f = parseInt(fondo.value, 10);
        const p = parseInt(peso.value, 10);
        if (![a, w, f, p].every(v => Number.isFinite(v) && v >= 1)) {
          // Marca el primer campo de dims inválido y no cierra.
          if (!Number.isFinite(a) || a < 1) alto.focus();
          else if (!Number.isFinite(w) || w < 1) ancho.focus();
          else if (!Number.isFinite(f) || f < 1) fondo.focus();
          else peso.focus();
          return;
        }
        _close();
        resolve({
          producto_id: 0,  // backend lo interpreta como flujo "pendiente"
          barcode: barcode.value.trim() || null,
          descripcion: d,
          cantidad: q,
          alto_mm: a, ancho_mm: w, fondo_mm: f, peso_g: p,
          fragil: fragil.checked,
          no_rotar: norotar.checked,
        });
      } else {
        const pid = parseInt(prodid.value, 10);
        if (!Number.isFinite(pid) || pid < 1) { prodid.focus(); return; }
        _close();
        resolve({
          producto_id: pid,
          barcode: barcode.value.trim() || null,
          descripcion: d,
          cantidad: q,
        });
      }
    });
  });
}
